export const APPOINTMENTS_GET_SEND = 'APPOINTMENTS_GET_SEND';
export const APPOINTMENTS_GET_RECEIVED = 'APPOINTMENTS_GET_RECEIVED';
export const APPOINTMENTS_GET_ERROR = 'APPOINTMENTS_GET_ERROR';
export const APPOINTMENTS_DELETE_SEND = 'APPOINTMENTS_DELETE_SEND';
export const APPOINTMENTS_DELETE_RECEIVED = 'APPOINTMENTS_DELETE_RECEIVED';
export const APPOINTMENTS_DELETE_ERROR = 'APPOINTMENTS_DELETE_ERROR';
export const APPOINTMENTS_UPDATE_SEND = 'APPOINTMENTS_UPDATE_SEND';
export const APPOINTMENTS_UPDATE_RECEIVED = 'APPOINTMENTS_UPDATE_RECEIVED';
export const APPOINTMENTS_UPDATE_ERROR = 'APPOINTMENTS_UPDATE_ERROR';
